// extracted by mini-css-extract-plugin
export default {"figure":"figure___4uFRm","scaleToViewport":"scaleToViewport___YbVBV","roundFigureImage":"roundFigureImage___3GNfe"};